"use client";
import {
  Box,
  Typography,
  Avatar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";

export default function Footer() {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isMd = useMediaQuery(theme.breakpoints.down("md"));

  const logoSize = isSm ? 80 : isMd ? 100 : 160;
  const gap = isSm ? 1 : isMd ? 2 : 4;

  const logos = [
    { src: "/MDILogo_white.png", altText: "Massive Data Institute logo" },
    { src: "/GULaw_white.png", altText: "Georgetown Law logo" },
    { src: "/ULondon_white.png", altText: "University of London Logo" },
  ];

  return (
    <Box
      component="footer"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      pt={{ xs: 3, sm: 0 }}
      px={{ xs: 2, sm: 6, md: 8 }}
      gap={2}
      sx={{
        width: "100%",
        backgroundColor: "#041E42",
      }}
    >
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        gap={gap}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="start"
          gap="0.3rem"
          flex={1}
          maxWidth={{ xs: "100%", sm: "60%" }}
          mr={{ sm: 2 }}
        >
          <Typography
            sx={{
              color: "#00ddff",
              fontSize: "1.2rem",
              fontWeight: "600",
            }}
          >
            #PublicDebtIsPublic
          </Typography>
          <Typography
            sx={{
              color: "white",
              fontSize: "0.9rem",
              fontWeight: "400 !important",
              width: "300px",
            }}
          >
            Making sovereign debt promises visible and understandable for all.
          </Typography>
          <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
            <Typography
              variant="body1"
              sx={{
                color: "white",
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSf6MYIZX50Dlhd1JD0r104an0wI_bK9F44Pcn5xtQzzjuSNww/viewform"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "white",
                  textDecoration: "underline !important",
                  fontWeight: "400 !important",
                }}
              >
                We want to hear from you
              </a>
            </Typography>
            <span style={{ color: "white" }}>|</span>
            <Typography
              sx={{
                color: "white",
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              <a
                href="/wp/terms_of_use/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontWeight: "400",
                  color: "white !important",
                  textDecoration: "underline !important",
                }}
              >
                Terms of Use
              </a>
            </Typography>
            <span style={{ color: "white" }}>|</span>
            <Typography
              sx={{
                color: "white",
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              <a
                href="/wp/gdpr-privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontWeight: "400",
                  color: "white !important",
                  textDecoration: "underline !important",
                }}
              >
                GDPR Privacy
              </a>
            </Typography>
          </div>
        </Box>
        <Box
          display="flex"
          justifyContent={{ xs: "center", sm: "flex-end" }}
          alignItems="center"
          gap={gap}
          flexWrap="wrap"
          flexShrink={0}
        >
          {logos.map((logo, i) => (
            <Avatar
              key={i}
              variant="rounded"
              sx={{
                width: logoSize,
                height: logoSize,
                bgcolor: "transparent",
                borderRadius: 3,
                overflow: "hidden",
              }}
            >
              <Image
                src={logo.src}
                alt={logo.altText}
                width={logoSize}
                height={logoSize}
                aria-hidden="true"
                style={{ objectFit: "contain" }}
              />
            </Avatar>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
